<div role="button" aria-label="Back to top of page" class="back-to-top-button" (click)="scrollTop($event)" [class.show]="showButton">
</div>
